import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import getResizedProductImage from '@repo/utils/getResizedProductImage';
import findCompareAtPriceRange from '@repo/utils/findCompareAtPriceRange';
import ProductCardGrid from '../../ProductCardGrid';
import ProductCard from '../../product-card';

function BlockBuilderProductGrid({ value: originalValue }) {
  const value = useMemo(() => {
    const result = {
      ...originalValue,
      products: originalValue?.products.map(product => ({
        ...product,
        store: product.store
          ? {
              ...product.store,
              variants: product.store.variants.map(variant => ({
                ...variant,
                store: !variant.store ? variant : variant.store,
              })),
            }
          : undefined,
      })),
    };

    return result;
  }, [originalValue]);

  return (
    <ProductCardGrid padding="0" className="blockbuilder-product-grid">
      {value?.products?.length > 0 &&
        value.products.map(sanityProduct => {
          if (sanityProduct?.store) {
            // Mapping of Sanity Product to Shopify format (our existing ProductCard)
            const product = {
              id: `${sanityProduct.store.id}`,
              title: sanityProduct.store.title,
              handle: sanityProduct.store.slug.current,
              productType: sanityProduct.store.productType,
              image: {
                src: getResizedProductImage(
                  sanityProduct.store.previewImageUrl
                ),
                altText: sanityProduct.store.title,
              },
              sku: sanityProduct.store.variants[0]?.store.sku,
              price: sanityProduct.store.variants[0]?.store.price,
              tags: sanityProduct.store.tags.split(','),
              priceRangeV2: {
                minVariantPrice: {
                  amount: sanityProduct.store.priceRange.minVariantPrice,
                  currencyCode: 'USD',
                },
                maxVariantPrice: {
                  amount: sanityProduct.store.priceRange.maxVariantPrice,
                  currencyCode: 'USD',
                },
              },
              compareAtPriceRange: findCompareAtPriceRange(sanityProduct),
              variants: sanityProduct.store.variants.map(variant => ({
                price: variant.store.price,
                compareAtPrice: variant.store.compareAtPrice,
              })),
              insights: () => null, // Algolia
              queryID: '', // Algolia
              features: sanityProduct.features,
            };

            return (
              <ProductCard
                key={product.id}
                product={product}
                sanityProduct={sanityProduct}
                showFeatureList={!value?.hideProductListingFeatures}
                showInlineRatings={!value?.hideRatings} // IFB currently does not have a reviews system
                hideProductPrices={value?.hideProductPrices}
              />
            );
          }
          return null;
        })}
    </ProductCardGrid>
  );
}

BlockBuilderProductGrid.propTypes = {
  value: PropTypes.shape({
    hideProductListingFeatures: PropTypes.bool,
    hideRatings: PropTypes.bool,
    hideProductPrices: PropTypes.bool,
    products: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

export default BlockBuilderProductGrid;
